"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networks = void 0;
exports.networks = {
    "1": {
        order: 1,
        chainName: "Ethereum Mainnet",
        chainId: 1,
        rpcUrls: [
            "https://main-rpc.linkpool.io",
            "https://eth-mainnet.public.blastapi.io",
            "https://eth-rpc.gateway.pokt.network",
        ],
        blockExplorerUrls: ["https://etherscan.io"],
        nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18,
        },
    },
    "56": {
        order: 3,
        chainName: "BNB Chain Mainnet",
        chainId: 56,
        rpcUrls: [
            "https://bsc-dataseed.binance.org",
            "https://bsc-dataseed1.defibit.io",
            "https://bsc-dataseed1.ninicoin.io",
        ],
        blockExplorerUrls: ["https://bscscan.com"],
        nativeCurrency: {
            name: "BNB",
            symbol: "BNB",
            decimals: 18,
        },
    },
    "137": {
        order: 5,
        chainName: "Polygon Mainnet",
        chainId: 137,
        rpcUrls: [
            "https://polygon-mainnet.public.blastapi.io",
            "https://matic-mainnet-archive-rpc.bwarelabs.com",
            "https://rpc-mainnet.matic.quiknode.pro",
            "https://polygon-rpc.com",
        ],
        blockExplorerUrls: ["https://polygonscan.com"],
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18,
        },
    },
    "181": {
        order: 6,
        chainName: "Waterfall Network",
        chainId: 181,
        rpcUrls: ["https://rpc.waterfall.network"],
        blockExplorerUrls: ["https://explorer.waterfall.network"],
        nativeCurrency: {
            name: "WATER",
            symbol: "WATER",
            decimals: 18,
        },
    },
    "10000": {
        order: 7,
        chainName: "Gemunion Mainnet",
        chainId: 10000,
        rpcUrls: ["https://besu.gemunion.io"],
        blockExplorerUrls: ["https://besu-explorer.gemunion.io"],
        nativeCurrency: {
            name: "GEM",
            symbol: "GEM",
            decimals: 18,
        },
    },
};
//# sourceMappingURL=networks.js.map